var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spl-header-login-holder"},[_c('header',{staticClass:"spl-header-login"},[_c('div',{staticClass:"spl-header-login__logo"}),_c('div',{staticClass:"spl-header-login__nav hide-on-mobile"})])])
}]

export { render, staticRenderFns }